export enum OrderableType {
  Movable,
  Static,
}
